var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED7AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collar",
    x1: 13,
    x2: 51,
    y1: 18,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11D48"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#collar)",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M17 27c2-8 9-13 17-12 10 1 17 9 16 19-1 9-9 16-18 15-8-1-14-7-15-15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF24",
    d: "M27 42h13v10H27z",
    rx: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#92400E",
    d: "M30 45h7v3h-7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M46 23c5 0 9 4 9 9h-6c0-2-1-3-3-3v-6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#60A5FA",
    d: "M47 29h7v16h-7z",
    rx: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessories);
export default __webpack_public_path__ + "static/media/accessories.d7e268b905750eb3e42dd2e21dd9f215.svg";
export { ForwardRef as ReactComponent };